__turbopack_context__.v({
  "hero": "SZt78W_hero",
  "heroBox": "SZt78W_heroBox",
  "heroButton": "SZt78W_heroButton",
  "heroContent": "SZt78W_heroContent",
  "heroImageBigDesktop": "SZt78W_heroImageBigDesktop",
  "heroImageDesktop": "SZt78W_heroImageDesktop",
  "heroImagePhone": "SZt78W_heroImagePhone",
  "heroImageTablet": "SZt78W_heroImageTablet",
  "heroTextAlign": "SZt78W_heroTextAlign",
  "heroTitle": "SZt78W_heroTitle",
  "heroUlBlock": "SZt78W_heroUlBlock",
  "heroUlListItem": "SZt78W_heroUlListItem",
  "threeLineEllipse": "SZt78W_threeLineEllipse",
});
